'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-343/node_modules/@eliadmin/core/src/components/pharmacy/avalability-check-form.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-343/node_modules/@eliadmin/core/src/components/pharmacy/avalability-check-form.tsx").AvailabilityCheckForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/availabilityCheckForm").then(m => ({ default: m.AvailabilityCheckForm })));
export function AvailabilityCheckForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

